var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.028 2C8.328 2 2.056 8.272 2.056 15.972v1.043a7.5 7.5 0 0 0-.056.47v8.119a7.28 7.28 0 0 1 .112-.274v.274c.252-.728.644-1.4 1.176-1.988 2.232-2.714 6.524-4.278 10.03-5.556h.001c1.992-.726 3.732-1.36 4.696-2.06.504-.364 1.232-.952.952-1.652-.28-.7-1.204-.98-1.848-1.148-4.925-1.493-1.125-4.016.945-5.39l.4-.266.024-.018c1.132-.821 3.66-2.654 2.382-4.294a2.53 2.53 0 0 0-1.064-.7c-1.13-.342-2.31-.486-3.491-.502m2.033 1.242c.013.07.022.14.025.213.19-.738-.485-1.103-1.15-1.284.586.17 1.16.483 1.125 1.072zM16.028 2a.51.51 0 0 0 .077.009z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluid);
export default __webpack_public_path__ + "static/media/FLUID.f47a39770c6366781af6e21b62a61da4.svg";
export { ForwardRef as ReactComponent };